import Vue from 'vue';
import VueRouter from 'vue-router';
// import Home from '../views/Home.vue';
import {careerRoutes} from "@/router/career";
// import NewGraduate from "@/views/NewGraduate.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/NewGraduate.vue'),
    meta: {
      title: 'TOP｜株式会社クレハ 採用サイト',
    },
  },
  {
    path: '/kureha-quiz',
    name: 'kureha-quiz',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/KurehaQuiz.vue'),
    meta: {
      title:
        'クレハ検定～環境と社会への取り組み編｜株式会社クレハ 採用サイト',
    },
  },
  {
    path: '/kureha-quiz-test',
    name: 'kureha-quiz-test',
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/KurehaQuizTest.vue'),
    meta: {
      title:
        'クレハ検定～環境と社会への取り組み編｜株式会社クレハ 採用サイト',
    },
  },
  {
    path: '/newgraduate/lab',
    name: 'lab',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/lab/Lab.vue'),
    meta: {
      title:
        '新卒採用 研究・技術職種 希望者向けページ｜株式会社クレハ 採用サイト',
    },
  },
  {
    path: '/newgraduate/lab/special',
    name: 'special',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/lab/Special.vue'),
    meta: {
      title:
        '新卒採用 スペシャルコンテンツ ～研究開発の落とし穴～｜株式会社クレハ 採用サイト',
    },
  },
  {
    path: '/newgraduate/lab/work',
    name: 'labwork',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/lab/Work.vue'),
    meta: {
      title:
        '新卒採用 クレハの仕事〈研究・技術職種〉｜株式会社クレハ 採用サイト',
    },
  },
  {
    path: '/newgraduate/lab/staff',
    name: 'staff',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/lab/Staff.vue'),
    meta: {
      title: '新卒採用 社員紹介〈研究・技術職種〉｜株式会社クレハ 採用サイト',
    },
  },
  {
    path: '/newgraduate/lab/staff/01',
    name: 'labstaff01',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/lab/Staff01.vue'),
    meta: {
      title: '新卒採用 研究開発 東瀬壮慶｜株式会社クレハ 採用サイト',
    },
  },
  {
    path: '/newgraduate/lab/staff/02',
    name: 'labstaff02',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/lab/Staff02.vue'),
    meta: {
      title: '新卒採用 技術営業 肖瑛閣｜株式会社クレハ 採用サイト',
    },
  },
  {
    path: '/newgraduate/lab/staff/03',
    name: 'labstaff03',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/lab/Staff03.vue'),
    meta: {
      title: '新卒採用 プロセス開発 高橋理沙｜株式会社クレハ 採用サイト',
    },
  },
  {
    path: '/newgraduate/lab/staff/04',
    name: 'labstaff04',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/lab/Staff04.vue'),
    meta: {
      title: '新卒採用 新規事業創出 今治誠｜株式会社クレハ 採用サイト',
    },
  },
  {
    path: '/newgraduate/lab/staff/05',
    name: 'labstaff05',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/lab/Staff05.vue'),
    meta: {
      title: '新卒採用 生産技術 小林暉｜株式会社クレハ 採用サイト',
    },
  },
  {
    path: '/newgraduate/lab/staff/06',
    name: 'labstaff06',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/lab/Staff06.vue'),
    meta: {
      title: '新卒採用 研究開発 四家彩｜株式会社クレハ 採用サイト',
    },
  },
  {
    path: '/newgraduate/lab/staff/07',
    name: 'labstaff07',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/lab/Staff07.vue'),
    meta: {
      title: '新卒採用 デジタル化推進 榊原志太郎｜株式会社クレハ 採用サイト',
    },
  },
  {
    path: '/newgraduate/lab/staff/08',
    name: 'labstaff08',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
        import(/* webpackChunkName: "about" */ '../views/lab/Staff08.vue'),
    meta: {
      title: '新卒採用 新事業開発 後健太｜株式会社クレハ 採用サイト',
    },
  },
  {
    path: '/newgraduate/gen',
    name: 'gen',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/gen/Gen.vue'),
    meta: {
      title: '新卒採用 企画・営業職種 希望者向けページ｜株式会社クレハ 採用サイト',
    },
  },
  {
    path: '/newgraduate/gen/staff',
    name: 'genstaff',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/gen/Staff.vue'),
    meta: {
      title: '新卒採用 社員紹介〈企画・営業職種〉｜株式会社クレハ 採用サイト',
    },
  },
  {
    path: '/newgraduate/gen/staff/01',
    name: 'genstaff01',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/gen/Staff01.vue'),
    meta: {
      title: '新卒採用 工業薬品部 営業 飯野真｜株式会社クレハ 採用サイト',
    },
  },
  {
    path: '/newgraduate/gen/staff/02',
    name: 'genstaff02',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/gen/Staff02.vue'),
    meta: {
      title: '新卒採用 PGA部 営業 LEE Juhee｜株式会社クレハ 採用サイト',
    },
  },
  {
    path: '/newgraduate/gen/staff/03',
    name: 'genstaff03',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/gen/Staff03.vue'),
    meta: {
      title: '新卒採用 海外 総経理助理 冨塚直人｜株式会社クレハ 採用サイト',
    },
  },
  {
    path: '/newgraduate/gen/staff/04',
    name: 'genstaff04',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
        import(/* webpackChunkName: "about" */ '../views/gen/Staff04.vue'),
    meta: {
      title: '新卒採用 東日本営業部 藤野早央里｜株式会社クレハ 採用サイト',
    },
  },
  {
    path: '/newgraduate/gen/work',
    name: 'genwork',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/gen/Work.vue'),
    meta: {
      title: '新卒採用 クレハの仕事〈企画・営業職種〉｜株式会社クレハ 採用サイト',
    },
  },
  {
    path: '/keyword',
    name: 'keyword',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/Keyword.vue'),
    meta: {
      title: 'クレハがわかる！7のキーワード｜株式会社クレハ 採用サイト',
    },
  },
  {
    path: '/info',
    name: 'info',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/Info.vue'),
    meta: {
      title: '募集要項 企画開発職系（総合職）｜株式会社クレハ 採用サイト',
    },
  },
  {
    path: '/office',
    name: 'office',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/Office.vue'),
    meta: {
      title: '事業所紹介｜株式会社クレハ 採用サイト',
    },
  },
  {
    path: '/faq',
    name: 'faq',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Faq.vue'),
    meta: {
      title: 'よくあるご質問｜株式会社クレハ 採用サイト',
    },
  },
  {
    path: '/midcareer',
    name: 'midcareer',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/Recruit.vue'),
    meta: {
      title: 'キャリア採用情報TOP｜株式会社クレハ 採用サイト',
    },
  },
  {
    path: '/product',
    name: 'product',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/Product.vue'),
    meta: {
      title: '事業と製品紹介｜株式会社クレハ 採用サイト',
    },
  },
  {
    path: '/career/info',
    name: 'mid-career',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/MidCareer.vue'),
    meta: {
      title: 'キャリア採用情報｜株式会社クレハ 採用サイト',
      desc: '「どこにも無ければ、創ればいい」 「ナケレバ、ツクレバ。」の精神で、自社開発にこだわって様々な研究を重ねてきた株式会社クレハのキャリア採用情報です。',
    },
  },
  {
    path: '/generalstaff',
    name: 'generalstaff',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ '../views/Generalstaff.vue'),
    meta: {
      title: '実務推進職系（一般職）｜株式会社クレハ 採用サイト',
    },
  },
  {
    path: '/newgraduate/',
    name: 'newgraduate',
    component: () => import('../views/Home.vue'),
    meta: {
      title: '新卒採用 企画開発職系（総合職）TOP｜株式会社クレハ 採用サイト'
    }
  },
    ...careerRoutes,
  {
    path: '*',
    component: () => import('@/views/NewGraduate.vue'),
    meta: {
      title: 'TOP｜株式会社クレハ 採用サイト',
    },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition; //戻る・進むのときには元々いた場所に戻る
    } else {
      return { x: 0, y: 0 }; //そうでないときはトップへ
    }
  },
});

export default router;
